/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRedirectedItem_viewer$ref = any;
export type SbSharedRedirectedItem_viewer = {
    readonly item?: {
        readonly title: string | null;
        readonly photos: ReadonlyArray<{
            readonly smallPath: string | null;
        } | null> | null;
    } | null;
    readonly __typename: "Viewer";
    readonly " $refType": SbSharedRedirectedItem_viewer$ref;
} & ({
    readonly __typename: "Viewer";
} | {
    /*This will never be '% other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
});



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRedirectedItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "itemId",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "hasItemId",
      "type": "Boolean",
      "defaultValue": false
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "__typename",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasItemId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "item",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "smallPath",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '29c3aedf1ab24c87a1d0376879f70f20';
export default node;
